// ID-044/047 RC-CS-UI-002/005: one palette for dealer + admin — terracotta = every active stage/status,
// amber = On hold (paused, needs a decision), green = project complete, gray = Lost / closed only
export const STAGE_CLASS = {
  done: "bg-terracotta text-white",
  current: "bg-terracotta text-white font-semibold ring-2 ring-terracotta/40 ring-offset-1",
  future: "bg-sand text-warmgrey",
};

export const CLOSED_STATUSES = ["LOST", "DECLINED", "CANCELLED"];

export function statusTone(status) {
  if (CLOSED_STATUSES.includes(status)) return "closed";
  if (status === "ON_HOLD") return "hold";
  if (status === "DELIVERED") return "complete";
  return "active";
}

const TONE_CLASS = {
  active: "bg-terracotta text-white",
  hold: "bg-amber-700 text-white",
  complete: "bg-status-available text-white",
  closed: "bg-zinc-600 text-white",
};

export function statusBadgeClass(status) {
  return TONE_CLASS[statusTone(status)];
}

export function StatusChip({ status, label, testid }) {
  return (
    <span className={`rounded-full px-2.5 py-1 text-[11px] font-semibold ${statusBadgeClass(status)}`} data-testid={testid} data-tone={statusTone(status)}>
      {label}
    </span>
  );
}
